import config from 'services/table/const';
import { currencyFormat } from 'utilities/common';

let table = { ...config };
table.url = '/wms/stock';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    alias: 'item.code',
    width: 80,
    component: (row) => {
      return (
        <div>
          <div className="text-ellipsis">{row?.item?.code}</div>
          <small className="text-ellipsis">
            {row?.item?.barcode ? `Barcode: ${row?.item?.barcode}` : null}
          </small>
        </div>
      );
    },
  },

  name: {
    title: 'Name',
    sortable: true,
    alias: 'item.code',
    width: 150,
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.item?.alias_name}
        </div>
      );
    },
  },

  categroy: {
    title: 'Kategori',
    class: 'text-start',
    width: 100,
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.item?.category}
        </div>
      );
    },
  },

  stock_available: {
    title: 'Stock Available',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 70,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {currencyFormat(row?.stock_available)} {row?.item?.default_fraction}
          </div>
          <small className="info">{row?.stock_available_fracted}</small>
        </div>
      );
    },
  },

  // stock_incoming: {
  //   title: 'Stock Incoming',
  //   sortable: true,
  //   class: 'text-center',
  //   classHeader: 'text-center',
  //   width: 80,
  //   component: (row) => {
  //     return <div>{currencyFormat(row?.stock_incoming)} {row?.item?.default_fraction}</div>;
  //   },
  // },

  stock_defect: {
    title: 'Stock Defect',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {currencyFormat(row?.stock_defect)} {row?.item?.default_fraction}
          </div>
          <small className="info">{row?.stock_defect_fracted}</small>
        </div>
      );
    },
  },
};
export default table;
